export default __webpack_public_path__ + "6875a3d6ab269fa54d8238f88e464075.svg";